import { actionCreator } from '@ardoq/rxbeach';
import { APIFieldAttributes } from '@ardoq/api-types';

export const fieldNamespace = 'fields';

type FieldOptions = {
  silent?: boolean;
  merge?: boolean;
  sort?: boolean;
};

export const addFields = actionCreator<{
  fields: APIFieldAttributes[];
  options?: FieldOptions;
}>('[fields] ADD_FIELDS');

export const resetFields = actionCreator<void>('[fields] RESET_FIELDS');

export const resetFieldsWithData = actionCreator<APIFieldAttributes[]>(
  '[fields] RESET_FIELDS_WITH_DATA'
);
